import { apiProps, apiConstructor } from './api.factory';
import OptionManager from './optionManager/optionManager.js';
import helper from '../helper';
import ActivedTabsHistory from './activedTabsHistory';
import Pub_Sub from './pub_sub.js';
import Tabs from './tabs.js';
import BaseApi from './baseApi.js';

var getDeps = function getDeps(options) {
  if (options === void 0) {
    options = {};
  }

  var activedTabsHistory = new ActivedTabsHistory(),
      optionsManager = new OptionManager({
    options: options
  });
  BaseApi.call(this, {
    helper: helper,
    initialState: optionsManager.initialState
  });
  Tabs.call(this, {
    initialTabs: optionsManager.initialTabs
  });
  Pub_Sub.call(this);
  return {
    activedTabsHistory: activedTabsHistory,
    helper: helper,
    optionsManager: optionsManager
  };
};

apiConstructor.prototype = Object.create(BaseApi.prototype);
helper.assingAll(apiConstructor.prototype, Tabs.prototype, Pub_Sub.prototype, apiProps).constructor = apiConstructor;
export default apiConstructor.bind(null, getDeps);